"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseAssignment = exports.CourseSection = exports.Course = void 0;
const Language_1 = require("./Language");
class Course {
    /** @internal */
    constructor({ amy, role, title, subtitle }) {
        this.title = new Language_1.Language();
        this.subtitle = new Language_1.Language();
        this.sections = [];
        this._amy = amy;
        this._role = role;
        this.title = title;
        this.subtitle = subtitle;
    }
}
exports.Course = Course;
class CourseSection {
    /** @internal */
    constructor({ title, subtitle }) {
        this.id = "";
        this.title = new Language_1.Language();
        this.subtitle = new Language_1.Language();
        this.sections = [];
        this.title = title;
        this.subtitle = subtitle;
    }
}
exports.CourseSection = CourseSection;
class CourseAssignment {
    /** @internal */
    constructor({ amy, role, title, subtitle }) {
        this.id = "";
        this.title = new Language_1.Language();
        this.subtitle = new Language_1.Language();
        this._amy = amy;
        this._role = role;
        this.title = title;
        this.subtitle = subtitle;
    }
    /**
     * @return Returns the student AssignmentId
     *
     * ## Example
     *
     * ```typescript
     * const studentAssignmentId = await CourseAssignment.start();
     * amy.studentAssignmentObserver(studentAssignmentId, ( studentAssignment )=>{
     *      console.log(studentAssignment)
     * })
     * ```
     *
     */
    async start() {
        return this._amy.startCourseAssignment({ role: this._role, courseAssignmentId: this.id });
    }
}
exports.CourseAssignment = CourseAssignment;
//# sourceMappingURL=Course.js.map